import { useEffect, useState } from 'react';
import { Users, Package, AirplaneTilt, Receipt, ShieldStar, Gavel, CheckSquare, Warning } from '@phosphor-icons/react';
import { API } from '@/App';

const Card = ({ icon: Icon, label, value, tone = 'purple' }) => {
  const toneMap = {
    purple: 'from-purple-500 to-pink-500',
    blue: 'from-blue-500 to-indigo-500',
    green: 'from-green-500 to-emerald-500',
    amber: 'from-yellow-500 to-orange-500',
    red: 'from-red-500 to-pink-600',
  };
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-5 shadow-sm" data-testid={`stat-${label.toLowerCase().replace(/\s+/g,'-')}`}>
      <div className={`w-10 h-10 rounded-lg bg-gradient-to-br ${toneMap[tone]} flex items-center justify-center mb-3`}>
        <Icon size={20} weight="fill" className="text-white" />
      </div>
      <p className="text-3xl font-extrabold text-gray-900" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>{value ?? '—'}</p>
      <p className="text-xs font-semibold uppercase tracking-widest text-gray-500 mt-1">{label}</p>
    </div>
  );
};

const AdminOverview = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    fetch(`${API}/admin/overview`, { credentials: 'include' })
      .then((r) => r.json()).then(setData).catch(() => {});
  }, []);

  return (
    <div>
      <h1 className="text-3xl font-extrabold text-gray-900 mb-1" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }} data-testid="overview-title">
        Operations Overview
      </h1>
      <p className="text-sm text-gray-500 mb-8">Real-time platform metrics across users, marketplace activity and compliance.</p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card icon={Users} label="Total Users" value={data?.users} tone="purple" />
        <Card icon={AirplaneTilt} label="Travelers" value={data?.travelers} tone="blue" />
        <Card icon={Package} label="Senders" value={data?.senders} tone="blue" />
        <Card icon={Receipt} label="Paid Bookings" value={data?.paid_bookings} tone="green" />

        <Card icon={Package} label="Parcels" value={data?.parcels} tone="purple" />
        <Card icon={AirplaneTilt} label="Trips" value={data?.trips} tone="purple" />
        <Card icon={CheckSquare} label="Delivered" value={data?.delivered} tone="green" />
        <Card icon={Gavel} label="Open Disputes" value={data?.open_disputes} tone={data?.open_disputes ? 'red' : 'green'} />

        <Card icon={ShieldStar} label="Active Rules" value={data?.compliance_rules_active} tone="amber" />
        <Card icon={Warning} label="Policy Violations" value={data?.policy_violations_24h} tone="amber" />
      </div>
    </div>
  );
};

export default AdminOverview;
